export enum Customs {
    None = 0,
    SimpleView = 1,
}